import { render, staticRenderFns } from "./SelectorArtistas.vue?vue&type=template&id=0caed8a0&scoped=true&"
import script from "./SelectorArtistas.vue?vue&type=script&lang=js&"
export * from "./SelectorArtistas.vue?vue&type=script&lang=js&"
import style0 from "./SelectorArtistas.vue?vue&type=style&index=0&id=0caed8a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caed8a0",
  null
  
)

export default component.exports